export default __webpack_public_path__ + "static/media/aus.54bd24f9.svg";